<template>
  <a-dialog v-model="show" max-width="500" small persistent>
    <v-card>
      <v-banner color="primaryLight1" dark sticky single-line tile>
        <v-toolbar color="primaryLight1" dark>
          <span>{{ $t("lblUnableEvent") }}</span>
        </v-toolbar>
      </v-banner>
      <v-card-text id="dialog-card-text">
        <span>{{ $t("lblSomethingwrong") }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              class="mr-2"
              color="secondary"
              @click="onDiscard"
            >
              {{ $t("btnDiscard") }}
            </a-btn>
          </template>
          <span> {{ $t("btnDiscard") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              color="primaryDark"
              @click.stop="editContinue"
            >
              {{ $t("btnEdit") }}
            </a-btn>
          </template>
          <span> {{ $t("btnEdit") }} </span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
export default {
  name: "ScheduleEventErrorDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  methods: {
    editContinue,
    onDiscard,
  },
};

function editContinue() {
  this.$emit("input", false);
}

function onDiscard() {
  this.$emit("discard");
  this.$emit("input", false);
}
</script>

<style>
</style>